import functions from "./functions";

$(() => {
    const isBlog = $('body').hasClass('blog');

    if( ! isBlog) return;

    const $form = $('form[id="blog-category"]');
    const form = $form[0];

    let urlData = functions.getUrlData();
    functions.setFormData(form, urlData);

    let pathname = location.pathname.split('/');
    let newPath = null;

    $('[name="category_name"]').on('click', e => {
        const $target = $(e.currentTarget);
        let categoryName = $target.val();
        let isChecked = $target.prop('checked');

        let data = {
            category_name: isChecked ? categoryName : null
        };

        $('[name="category_name"]').each((index, category) => {
            const $category = $(category);
            if($category.attr('id') != categoryName) {
                $category.prop('checked', false);
            }
        });

        newPath = '/' + pathname[1] + '/';

        location = newPath + (data.category_name ? '?' + $.param(data) : '');
    });

    /*$form.on('change', e => {
        const $target = $(e.currentTarget);
        let data = functions.getFormData($target);

        functions.setUrlData(data, false);
    });*/
});